import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/letterhead',
  component: Layout,
  name: 'letterhead',
  redirect: '/letterhead/index',
  children: [{
    path: '/letterhead/index',
    component: () => import('@/views/letterhead/index'),
    name: 'letterhead.index',
    meta: {
      title: i18n.t(`message.graphic`)
    }
  }, ]
}

export default schedule